import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    constructor(private snackbar: MatSnackBar) {}

    error(message?: string, duration = 4000) {
        this.snackbar.open(message ? message : 'Something Went Wrong!', 'x', {
            duration,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
    success(message?: string, duration = 4000) {
        this.snackbar.open(message ? message : 'Saved Successfully', 'x', {
            duration,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
}
